/**
 * DevDebug - A utility for development-only logging
 * 
 * Only logs messages in development environment
 * Silently ignores logs in production
 */

// Check if we're in development environment
const isDev = process.env.NODE_ENV === 'development';

// Create namespace support for better organization
const createNamespace = (namespace: string) => {
  const prefix = namespace ? `[${namespace}] ` : '';
  
  return {
    log: (...args: any[]) => {
      if (isDev) console.log(prefix, ...args);
    },
    info: (...args: any[]) => {
      if (isDev) console.info(prefix, ...args);
    },
    warn: (...args: any[]) => {
      if (isDev) console.warn(prefix, ...args);
    },
    error: (...args: any[]) => {
      if (isDev) console.error(prefix, ...args);
    },
    group: (label: string) => {
      if (isDev) console.group(`${prefix}${label}`);
    },
    groupEnd: () => {
      if (isDev) console.groupEnd();
    },
    // Add a method to log only in specific environments
    // For example: devDebug.env('staging').log('This only logs in staging')
    env: (environment: string) => {
      const isTargetEnv = process.env.NEXT_PUBLIC_APP_ENV === environment;
      return {
        log: (...args: any[]) => {
          if (isDev && isTargetEnv) console.log(prefix, ...args);
        },
        info: (...args: any[]) => {
          if (isDev && isTargetEnv) console.info(prefix, ...args);
        },
        warn: (...args: any[]) => {
          if (isDev && isTargetEnv) console.warn(prefix, ...args);
        },
        error: (...args: any[]) => {
          if (isDev && isTargetEnv) console.error(prefix, ...args);
        }
      };
    }
  };
};

// Default instance without namespace
const devDebug = createNamespace('');

// Export both the default instance and the namespace creator
export { devDebug, createNamespace };
export default devDebug;